import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=4c6f0cd4&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=ts&"
export * from "./Compare.vue?vue&type=script&lang=ts&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=4c6f0cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f0cd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VToolbar,VToolbarTitle})
